enum ETreeNodeAccessRightNames {
  Modify = 'Modify',
  Read = 'Read',
  NodeVisible = 'NodeVisible',
}

export default ETreeNodeAccessRightNames;
